import OpenInNew from "@mui/icons-material/OpenInNew";
import { Box, GlobalStyles, Link } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ICON_SIZE } from "@/theme/tokens";
import { TEST_ID } from "./consts";

/**
 * What a framed window shows for any address outside the public careers page: one link that opens that address in its
 * own tab, where the app's usual sign-in and framing rules apply. Never the app itself inside someone else's page.
 */
export const FramedRouteNotice: FC = () => {
	const { t } = useTranslation();
	const { pathname, search } = useLocation();
	return (
		<Box sx={{ p: 2 }} data-testid={`${TEST_ID}-framed-route-notice`}>
			<GlobalStyles styles={{ "html, body": { backgroundColor: "transparent" } }} />
			<Link
				href={`${pathname}${search}`}
				target="_blank"
				rel="noopener noreferrer"
				sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
				data-testid={`${TEST_ID}-framed-route-open`}
			>
				{t("publicCareers.framed.open_in_new_tab")}
				<OpenInNew sx={{ fontSize: ICON_SIZE.INLINE }} aria-hidden />
			</Link>
		</Box>
	);
};
